import React, { useEffect } from "react";
import { ExclamationCircleIcon, CheckCircleIcon } from "@heroicons/react/solid";
import useGetChatList from "../../hooks/chats/useGetChatList";
import PrimaryLoader from "../../components/common/PrimaryLoader";
import ChatListItem from "./ChatListItem"; // Reuse the existing ChatListItem component
import Button from "../../components/ui/Button";

const NeedsAttentionList = ({
  handleChatSelect,
  selectedChatId,
  refreshTrigger,
}) => {
  // Use the custom hook with screen="NEEDS_ATTENTION"
  const { chatList, loading, error, refetch } = useGetChatList(
    10,
    1,
    "NEEDS_ATTENTION"
  );

  // Listen for refresh triggers from parent
  useEffect(() => {
    if (refreshTrigger) {
      refetch();
    }
  }, [refreshTrigger, refetch]);

  if (loading) {
    return (
      <div className="overflow-auto flex-1 p-2 flex justify-center items-center">
        <PrimaryLoader />
      </div>
    );
  }

  if (error) {
    return (
      <div className="overflow-auto flex-1 p-2 flex justify-center items-center">
        <p className="text-red-500">Error loading attention requests</p>
      </div>
    );
  }

  if (chatList.length === 0) {
    return (
      <div className="overflow-auto flex-1 p-2 flex flex-col items-center justify-center">
        <ExclamationCircleIcon className="w-10 h-10 text-gray-400 mb-2" />
        <p className="text-gray-500 text-center">
          No attention requests at this time
        </p>
      </div>
    );
  }
  /* Original implementation
  return (
    <div className="overflow-auto flex-1 p-2">
      {needsAttentionList.length === 0 ? (
        <div className="flex flex-col items-center justify-center p-6 h-full">
          <p className="text-gray-500">No attention requests</p>
        </div>
      ) : (
        <div>
          {/* Active requests section *\/}
          {needsAttentionList.filter(item => !item.resolved).length > 0 && (
            <>
              <h3 className="text-xs uppercase text-gray-500 font-semibold px-2 py-1">Active Requests</h3>
              <ul className="mb-4">
                {needsAttentionList.filter(item => !item.resolved).map(item => (
                  <li key={item.id} className="p-3 mb-2 bg-white rounded-lg shadow-sm border border-red-100">
                    <div className="flex items-start space-x-3">
                      <img 
                        src={item.img} 
                        alt={item.name} 
                        className="w-12 h-12 rounded-full object-cover"
                      />
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center justify-between">
                          <p className="font-medium">{item.name}</p>
                          <ExclamationCircleIcon className="w-5 h-5 text-red-500 flex-shrink-0" />
                        </div>
                        
                        {/* Rearranged layout for attention status and timestamp *\/}
                        <div className="flex items-center justify-between mt-1">
                          <div className="flex flex-col">
                            <p className="text-xs text-red-500 font-medium">Needs your attention</p>
                            <p className="text-xs text-gray-500 mt-1">{item.timestamp}</p>
                          </div>
                          <Button
                            onClick={() => handleResolve(item.id)}
                            className="bg-white text-red-600 border border-red-300 rounded-full text-xs hover:bg-red-50 transition-colors self-center"
                          >
                            Resolve
                          </Button>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </>
          )}
          
          {/* Resolved requests section *\/}
          {needsAttentionList.filter(item => item.resolved).length > 0 && (
            <>
              <h3 className="text-xs uppercase text-gray-500 font-semibold px-2 py-1">Resolved</h3>
              <ul>
                {needsAttentionList.filter(item => item.resolved).map(item => (
                  <li key={item.id} className="p-3 mb-2 bg-gray-50 rounded-lg">
                    <div className="flex items-start space-x-3">
                      <img 
                        src={item.img} 
                        alt={item.name} 
                        className="w-12 h-12 rounded-full object-cover opacity-70"
                      />
                      <div className="flex-1 min-w-0">
                        <div className="flex items-center justify-between">
                          <p className="font-medium text-gray-500">{item.name}</p>
                          <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0" />
                        </div>
                        <div className="flex justify-between items-center mt-1">
                          <div className="flex flex-col">
                            <p className="text-xs text-gray-400">Requested {item.timestamp}</p>
                            <p className="text-xs text-gray-400 mt-1">Resolved {item.resolvedTime}</p>
                          </div>
                          <span className="text-xs text-gray-400 bg-gray-200 px-2 py-0.5 rounded-full self-center">
                            Resolved
                          </span>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>
            </>
          )}
        </div>
      )}
    </div>
  );
  */
  return (
    <div className="overflow-auto flex-1">
      <ul className="p-0">
        {chatList.map((chatItem) => (
          <ChatListItem
            key={chatItem.chat_id}
            chatItem={chatItem}
            isSelected={selectedChatId === chatItem.chat_id}
            onClick={() => handleChatSelect(chatItem)}
          />
        ))}
      </ul>
    </div>
  );
};

export default NeedsAttentionList;
